import {useQuery} from "@tanstack/react-query";
import {getData} from "../../../app/getters/getData.js";

export const useDostepneStatusyPlanHarm = (planHarmId, enabled = true) => {
    return useQuery({
        queryKey: [`dostepne_statusy_plan_harm`, planHarmId],
        queryFn: () => getData(`/oper/plan-harm/proces/dostepne-statusy/${planHarmId}`),
        enabled: enabled && !!planHarmId
    })
}
